import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Row } from 'react-bootstrap';
import { Button, Container } from 'reactstrap';
import { Breadcrumbs, Typography, IconButton, InputBase, Paper } from "@mui/material";
import ProjectMemberEditModal from './ProjectMemberEditModal';
import PaginationTableWithFuncBtn from '../../../components/Util/PaginationTableWithFuncBtn';
import toastAlert from '../../../js/Base/ToastAlert';
import moment from 'moment';
import AddIcon from "@mui/icons-material/Add";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchIcon from '@mui/icons-material/Search';
import { useSelector, useDispatch } from "react-redux";
import { fetchBusinessMembers } from '../../../store/slices/businessSlice';
import {
  getProjectMembersByProjectId,
  getCompanyMembersNotInProject,
  deleteProjectMember
} from '../../../api/projectApi';

export default function ProjectMemberManagement() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  
  const [loading, setLoading] = useState(true);
  const [addModalOpen, setAddModalOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectProjectMember, setselectProjectMember] = useState(null);
  const [memberList, setMemberList] = useState([]);
  const userName = localStorage.getItem('user_email');
  const projectUuid = localStorage.getItem("project_uuid");
  const companyUuid = localStorage.getItem("company_uuid");

  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchBusinessMembers());
      await getProjectMembers();
      const members = await fetchCompanyMembersNotInProject();
      setMemberList(members || []);
    };
    fetchData();
  }, []);

  const isEdcAdmin = useSelector(state => state.businessMembers.isEdcAdmin);

  const refreshData = async () => {
    await getProjectMembers();
    const members = await fetchCompanyMembersNotInProject();
    setMemberList(members || []);
  };

  // 公司成員清單
  const fetchCompanyMembersNotInProject = async (searchKeyword = null) => {
    try {
      const res = await getCompanyMembersNotInProject({
        company_uuid: companyUuid,
        project_uuid: projectUuid,
        search: searchKeyword,
      });
  
      const data = res.data;

      if (data.success) {
        return data.data.items;
      } else {
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
        return [];
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      return [];
    }
  };

  const getProjectMembers = async () => {
    if (!projectUuid) {
      toastAlert.autoClose(true).showError("查無資料，請聯絡系統管理員");
      return;
    }

    setLoading(true);

    try {
      const res = await getProjectMembersByProjectId(userName, projectUuid);
      const data = res.data;
      if (data.success) {
        setRows(data.members);
      } else {
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      }

    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    } finally {
      setLoading(false);
    }
  };

  const handleAddModalOpen = () => setAddModalOpen(true);
  const handleAddModalClose = () => setAddModalOpen(false);
  const handleSearchChange = (e) => setSearch(e.target.value);

  const handleEdit = (id) => {
    toggleModal(id);
  };
  
  const toggleModal = (memberUuid = null) => {
    const member = rows.find((m) => m.uuid === memberUuid) || null;
    setselectProjectMember(member);
    setIsModalOpen(true);
  };
  const handleEditModalClose = () => {
    setIsModalOpen(false);
    setselectProjectMember(null);
  };

  const handleDelete = async (memberUuid) => {
    try {
      const res = await deleteProjectMember({
        project_member_uuid: memberUuid,
      });
  
      const data = res.data;

      if (data.success) {
        toastAlert.autoClose(true).showSuccess("刪除成功");
        refreshData();
      } else {
        toastAlert.autoClose(true).showError("刪除失敗");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    }
  };
  const { email, isAdmin } = useSelector(state => state.user);
  const col_name = ["姓名", "帳號", "角色", "加入專案日期", "動作"];
  const data_frame = [
    { keyName: 'name', isBadge: false },
    { keyName: 'email', isBadge: false },
    { keyName: 'role_name', isBadge: false },
    { keyName: 'join_dt', isBadge: false },
    { keyName: 'func', isClick: true, editBtn: true, delBtn: true },
  ];
  const col_size = ['15%', '15%', '37%', '15%', '18%'];
  const new_project_members_by_project_no = rows.map((data) => {
    const roleList = data.member_role_list || [];
    const filteredRoles = isAdmin || isEdcAdmin ? roleList
      : roleList.filter(r => r.role_name !== "eDC Admin");
  
    return {
      ...data,
      join_dt: !data.join_dt ? '' : moment.utc(data.join_dt).local().format('YYYY-MM-DD HH:mm'),
      role_name: filteredRoles.map(r => r.role_name).join(", "),
    };
  });

  return (
    <React.Fragment>
      <Container className="mt-2">
        <div className="ProjectManagement" style={{ marginRight: '20px' }}>
          <Breadcrumbs
            className="link-area"
            style={{ padding: "0 0 20px 0", fontWeight: 'bold'}}
            separator={<NavigateNextIcon style={{ fontSize: '20px', fontWeight: 'bold' }} />}
            aria-label="breadcrumb"
          >
            <Link to="/admin-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>人員管理</p>
            </Link>
            <Link to="/project/project-member-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>專案人員管理</p>
            </Link>
          </Breadcrumbs>

          <Card>
            <Card.Header style={{ backgroundColor: "transparent" }}>
              <strong className="text">專案人員管理</strong>
              {new_project_members_by_project_no !== null && (
                <IconButton
                  onClick={() => toggleModal(null)}
                    sx={{
                      color: "black",
                      width: 32,
                      height: 32,
                    }}
                  >
                    <Typography variant="h6" component="span" sx={{ lineHeight: 1 }}>
                      <AddIcon fontSize="medium" />
                    </Typography>
                </IconButton>
              )}
            </Card.Header>
            <Card.Body style={{ paddingTop: "5px" }}>
              <Row className="mb-3 mt-3">
                <Col md={8}></Col>
                <Col md={4}>
                  <Paper variant="outlined" component="form" sx={{ p: '2px 2px', display: 'flex', alignItems: 'left', height: '32px' }}>
                    <InputBase
                      sx={{ flex: 1, p: '10px' }}
                      style={{ fontSize: '12px', boxShadow: 'none' }}
                      placeholder="請輸入姓名或帳號"
                      inputProps={{ 'aria-label': 'search keyword' }}
                      value={search}
                      onChange={handleSearchChange}
                    />
                    <IconButton type="button" sx={{ p: '12px' }} aria-label="search">
                      <SearchIcon style={{ color: '#E2E2E2' }} />
                    </IconButton>
                  </Paper>
                </Col>
              </Row>

              <>
                {new_project_members_by_project_no !== null ? (
                  <PaginationTableWithFuncBtn
                    rowData={new_project_members_by_project_no.filter((m) =>
                      m.name.indexOf(search) > -1 || m.email.indexOf(search) > -1
                    )}
                    colName={col_name}
                    dataFrame={data_frame}
                    col_size={col_size}
                    editModalOpen={handleEdit}
                    delFunc={handleDelete}
                  />
                ) : (
                  <Col md={12} className="d-flex justify-content-end align-items-center mt-2 mb-2">
                    <Button
                      style={{ width: '90px', height: '34px', fontSize: '14px', fontWeight: 'bold' }}
                      outline
                      onClick={() => toggleModal(null)}
                    >
                      新增
                    </Button>
                  </Col>
                )}

                <ProjectMemberEditModal
                  isModalOpen={isModalOpen}
                  handleClose={handleEditModalClose}
                  projectMember={selectProjectMember}
                  isCreate={selectProjectMember === null}
                  submitEffect={refreshData}
                  companyMemberList={memberList}
                />
              </>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
}
